const STORAGE_ID = 'bekat_kb_settings_customer_id'
const STORAGE_NAME = 'bekat_kb_settings_customer_name'

export function rememberSettingsCustomer(customerId, customerName) {
  if (customerId == null || customerId === '') {
    return
  }
  try {
    sessionStorage.setItem(STORAGE_ID, String(customerId))
    if (customerName) {
      sessionStorage.setItem(STORAGE_NAME, String(customerName))
    }
  } catch {
    // ignore quota / private mode
  }
}

export function getRememberedSettingsCustomer() {
  try {
    return sessionStorage.getItem(STORAGE_ID) || ''
  } catch {
    return ''
  }
}

export function getRememberedSettingsCustomerName() {
  try {
    return sessionStorage.getItem(STORAGE_NAME) || ''
  } catch {
    return ''
  }
}

export function settingsOverviewPath(customerId) {
  const id = customerId || getRememberedSettingsCustomer()
  return id ? `/settings?customer=${id}` : '/settings'
}

export function customerKbPath(customerId) {
  const id = customerId || getRememberedSettingsCustomer()
  return id ? `/customers/${id}` : null
}

export function manageCategoriesPath(_customerId) {
  return '/manage-categories'
}
